module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "grid-list-lg": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "userInfo",
    attrs: {
      "lg12": ""
    }
  }, _vm._l((_vm.rfcHistory), function(history) {
    return _c('div', {
      staticClass: "historyBox"
    }, [_c('table', {
      attrs: {
        "width": "100%"
      }
    }, [_c('tr', [_c('td', [_c('strong', [_vm._v("NEW STATUS:")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(history.new_value))])]), _vm._v(" "), _c('tr', [_c('td', [_c('strong', [_vm._v("PREVIOUS STATUS:")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(history.prev_value))])]), _vm._v(" "), _c('tr', [_c('td', [_c('strong', [_vm._v("DATE CHANGED:")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(history.timestamp))])]), _vm._v(" "), _c('tr', [_c('td', [_c('strong', [_vm._v("CHANGED BY:")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(history.name))])]), _vm._v(" "), _c('tr', [_c('td', [_c('strong', [_vm._v("COMMENTS:")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.fncCheckComment(history.data)))])])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "pl-4 pr-1 pb-4 buttonHolder"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right cancelButton",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncHideModal.apply(null, arguments)
      }
    }
  }, [_vm._v("Close")])], 1)])], 1)], 1)
},staticRenderFns: []}